import apiUrl from '../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import {
  Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import {
  BasicSelect
} from 'vue-search-select'
import Paginate from 'vuejs-paginate'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import { variables } from '../../../../config'
import { AWBNumberNormslization } from '../../../services/utility';

export default {
  name: 'investigationactionbyoperation',
  components: {
    BasicSelect,
    Paginate,
    VueElementLoading,
    Multiselect
  },
  data() {
    return {
      show: false,
      myStr: '',
      listUserData: [],

      isLoading1: false,
      resultCount: '',
      pagecount: 1,
      pageno: 0,
      currentPage: 1,
      totalPages: 0,
      exportdis: '',
      ucgstatus: '',
      awbnumber: '',
      fromdate: '',
      todate: '',
      status: '',
      statuss: [{
        value: '1',
        label: 'Dead on Arrival'
      }, {
        value: '2',
        label: 'Sold'
      }, {
        value: '4',
        label: 'Dispose'
      },
      ],

      showeditmodel: false,
      currentdateminus180: '',
      currentdate:moment(new Date()).format("YYYY-MM-DD"),
      totalcount: 0

    }
  },
  mounted() {
    var userToken = window.localStorage.getItem('accessuserToken');
    this.myStr = userToken.replace(/"/g, '');

  },
  computed: {

    ExportDisableds: function () {
      return (this.exportdis == '') ? true : false;
    },
  },

  methods: {
    resetForm() {

      this.status = '';
      this.awbnumber='';
      this.todate = '';
      this.fromdate = '';
      this.newhubs = '';
      this.fromdate='';
      this.todate='';
      this.exportdis = '';
        this.isLoading = false;
      this.$validator.reset(); this.errors.clear();
      this.isLoading1 = false;
      this.listUserData = []; this.pageno = 0; this.resultCount = ''; this.pagecount = 1; this.totalRows = '';

    },

    searchUserData() {
      this.pageno = 0;
      this.$refs.paginate.selected = 0;
      this.searchData();
    },

    //to get pagination
    getPaginationData(pageNum) {
      this.pageno = (pageNum - 1) * variables.pageRecordLimit
      this.searchData(this.pageno)
    },
    //searchbutton
    searchData(pageNo) {
      this.awbnumber = AWBNumberNormslization(this.awbnumber).toString();
      this.exportdis = 1;
      this.listUserData = []; this.resultCount = ''; this.pagecount = 1; this.totalRows = '';
      this.totalcount = 0
      this.isLoading1 = true
      var d = new Date();
      let daysto = d.setDate(d.getDate() - 180);
      this.currentdateminus180 = moment(new Date(daysto)).format("YYYY-MM-DD")
      if ((this.fromdate && !this.todate) || (!this.fromdate && this.todate)) {
        this.$alertify.error("Please enter both  date")

      }
      else if (this.fromdate > this.todate) {
        this.$alertify.error("From date should not be greater than To date")

      } else if ((this.fromdate && this.todate) || (!this.fromdate && !this.todate)) {

      if (this.fromdate != '' && this.todate != ''  ) {

        this.input = ({

          offset: pageNo,
          limit: variables.pageRecordLimit,
          shippingid: this.awbnumber,
          FromDate: this.fromdate.slice(0, 10) + " 00:00:00",
          ToDate: this.todate.slice(0, 10) + " 23:59:59",
          ucgstatuscode:this.status.value

        });
      } else {

        this.input = ({
          shippingid: this.awbnumber,
          FromDate: this.currentdateminus180.slice(0, 10) + " 00:00:00",
          ToDate: this.currentdate.slice(0, 10) + " 23:59:59",
          offset: pageNo,
          limit: variables.pageRecordLimit,
          ucgstatuscode:this.status.value

        })

      }
      console.log(this.status.value);
      axios({
        method: 'post',
        url: apiUrl.api_url + 'Searchucghubinventorymaster',
        data: this.input,
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }
      }).then(result => {
        this.listUserData = result.data.data;
        this.totalcount = result.data.count
        if (this.totalcount == undefined) {
          this.totalcount = 0
        }
        this.resultCount = result.data.data.length
        if (this.resultCount < variables.pageRecordLimit) {
          this.pagecount = 1
        } else {
          this.pagecount = Math.ceil(result.data.count / variables.pageRecordLimit)
        }

      })
    }//else
    },
    exportfileCSV() {
      this.isLoading1 = true;
      this.downloadCSV(this.listUserData);
    },

    async downloadCSV(result) {
      var csvData = result;
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear();
      var today = dd + "" + mm + "" + yyyy;
      var data, filename, link;
      filename = "Searchucghubinventorymaster" + today + ".csv";
      var csv = await this.convertArrayOfObjectsToCSV({
        data: csvData
      });
      if (csv == null) return;
      filename = filename || "export.csv";
      if (!csv.match(/^data:text\/csv/i)) {
        csv = "data:text/csv;charset=utf-8," + csv;
      }
      data = csv;
      link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
    },
    convertArrayOfObjectsToCSV: function (args) {
      var result, ctr, keys, columnDelimiter, lineDelimiter, data;
      data = args.data || null;
      if (data == null || !data.length) {
        return null;
      }
      columnDelimiter = args.columnDelimiter || ",";
      lineDelimiter = args.lineDelimiter || "\n";
      keys = Object.keys(data[0]).slice(0);
      result = "";
      result += keys.join(columnDelimiter);
      result += lineDelimiter;
      for (let i = 0; i < data.length; i++) {

        result += data[i].shippingid + ',' + data[i].ucgstatuscode + ',' + data[i].netpaymentreceived + ',' + data[i].description + ',' + data[i].solddisposedate + ',' + data[i].createddate + ',';
        result += lineDelimiter;
      }
      return result;
    },

  }
}



// WEBPACK FOOTER //
// ./src/views/components/UCGInventoryReport/UCGInventoryReport.component.js